import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class DownloadCsvTransactions {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(transaction_ids:[string], uuid:string|number, listFilters?): Promise<any> {
    let args = { 
      transaction_ids: transaction_ids,
    }
    try {
      this.frontend.action = 'download_csv'
      let res = await this.dispatcher.dispatch('download.csv.transactions', args)
      this.frontend.asyncJobState = 'running';
      this.frontend.asyncJobId = res.job_id
    } catch (error) {
      console.error('Error download csv transactions', error)
    }
  }
}